export let trMessages={
  "privacy_policy_and_terms_of_use":"Privacy Policy and Terms of Use ",   // todo
  "privacy_confirm_text":"We've updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>Privacy Policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>Terms of Use</a>. To continue using EasyView, you need to read and agree to all the terms.",   // todo
  "privacy_confirm_disagree":"Disagree",   // todo
  "privacy_confirm_accept":"Accept",   // todo

  "title":"EasyView Personal",   // todo
  "title1":"EasyView Pro",   // todo
  "user":"E-posta",
  "password":"Parola",
  "remember":"Beni Hatırla",
  "forget":"Parolanızı mı unuttunuz?",
  "sign in":"Oturum aç",
  "login":"Login",   // todo
  "sign up now":"Şimdi kayıt ol",
  "apply":"Bir hesap için başvur",
  "contact us":"Bizimle iletişime geçin",
  "Privacy Policy":"Gizlilik Politikası",
  "Terms of Use":"Kullanım Şartları",
  "copyright":"Telif Hakkı © 2021 Medtrum Technologies Inc. Tüm hakları saklıdır.",

  "chooseLang":"Ülkenizi veya dilinizi seçin",
  "asia":"Asia Pacific",   // todo
  "europe":"Avrupa",
  "middleEast":"Middle East",   // todo

  "applyHcp":"HCP hesabı için başvurun",
  "sign up":"Kayıt ol",
  "Patient":"Hasta",
  "Caregiver":"Bakıcı",
  "Email":"E-posta",
  "Mobile":"Mobil",
  "Enter email":"E-mail adresini girin",
  "Enter mobile":"Cep telefonu numarasını girin",
  "Verification":"Doğrulama kodu",
  "Invitation":"Invitation code",   // todo
  "full name":"Tam Adınızı ve soyadınızı girin",
  "Enter pass":"Enter password",   // todo
  "org":"Organizasyon",
  "Register":"Register",   // todo
  "send":"Gönder",
  "createAccount":"Create Account",   // todo
  "agree":"I have read and agree to the ",   // todo
  "privacy":" Medtrum privacy policy  ",   // todo
  "and":"ve",
  "use":"terms of service.",   // todo
  "errtip1-1":"You must enter a valid email address,which",   // todo
  "errtip1-2":"will become your Medtrum username.",   // todo
  "errtip2":"Please enter a valid mobile number.",   // todo
  "errtip3":"Doğrulama kodu yanlış",
  "errtip4":"Incorrect invitation code.",   // todo
  "errtip5":"Kullanıcı adı yanlış",
  "errtip6":"Your password must have 8 or more characters.",   // todo
  "errtip7":"Please enter your organization.",   // todo

  "errp1":"Password must contain at least 3 types of the following characters:",   // todo
  "errp2":"capital letter,lowercase letter, number and special character.",   // todo
  "errp3":"Parola uzunluğu 6 ile 20 karakter arasında olmalıdır.",
  "errp4":"Parola kullanıcı adından farklı olmalıdır.",
  "errp5":"Ardışık 3 rakamı içermekte olan parola geçersizdir (örneğin, 123, 321).",
  "errp6":"Ardışık 3 sayıyı harfi içermekte olan Parola geçersizdir (örneğin, abc, cba).",
  "errp7":"Parola boşluk içeremez.",


  "Find account":"Parolanızı alın.",
  "Enter username":"Lütfen kullanıcı adınızı giriniz.",
  "Next":"Sonraki",
  "Cancel":"İptal",
  "Back":"Geri",
  "Enter veri":"Enter verification code",   // todo
  "Verify notice":"Lütfen bir e-posta ile gönderilen doğrulama kodunu bulun.",
  "Create new":"Yeni bir parola oluştur",
  "Create new notice":"Lütfen yeni bir parola oluşturun ve parolanız 6 veya daha fazla karakter içermelidir.",
  "New pass":"Yeni Parola",
  "Completed":"Tamamlandı",
  "Created":"Yeni parola oluşturuldu.",
  "Login Now":"Şimdi giriş yapın",

  "Delete":"Sil",
  "New Patient":"Yeni Hasta",
  "Add Patient":"Hasta Ekle",
  "Filter":"Filtre",
  "Name":"isim",
  "Gender":"Cinsiyeti",
  "Age":"Yaş",
  "Type":"Türü",
  "Duration":"Süre",
  "Connections":"Hesap oluşturucu",
  "UploadTime":"Yükleme süresi",
  "Year":"year",   // todo
  "Years":"years",   // todo
  "Month":"month",   // todo
  "Month2":"Ay",
  "Months":"months",   // todo
  "Invite":"Davet",
  "Invited":"Davetli",
  "All":"Hepsi",
  "Female":"Kadın",
  "Male":"Erkek",
  "Not Set":"Not Set",   // todo
  "Type 1":"Tip 1",
  "Type 2":"Tip 2",
  "Gestational":"Gebe",
  "Prediabetes":"Prediyabet ",
  "LADA":"Tip 1,5 LADA",
  "Apply":"Uygula",
  "disUn":"Diabetes type unspeficied",   // todo
  "ageUn":"Yaş belirtilmemiş",
  "genUn":"Cinsiyet belirtilmemiş",
  "addP":"Hasta ekle",
  "newP":"Yeni Hasta",
  "findP":"Hasta Bul",

  "GDRNF":"Belirtilmemiş",
  "GDRF":"Kadın",
  "GDRM":"Erkek",
  "女":"Erkek",

  "DBTNF":"Belirtilmemiş ",
  "DBT1":"Tip 1",
  "DBT2":"Tip 2",
  "DBTLADA":"Tip 1,5 LADA",
  "DBTPRE":"Prediyabet",
  "DBTGEST":"Gebe",
  "前期":"beFore",   // todo
  "beFore":"beFore",   // todo
  "MODY":"Mody",   // todo

  "No selection":"No selection",   // todo
  "unspecif":"unspecified",   // todo
  "register":"Hasta",
  "hcp":"Klinik tedavi uzmanı",

  "BG":"BG",
  "CARB":"Karbonhidrat",
  "INS":"Enjeksiyon",
  "EXR":"Egzersiz",
  "OTR":"Diğer",
  "HBA1C":"HbA1c",
  "DOSE":"DOSE",   // todo
  "URINEK":"İdrar Ketonu",
  "HEL":"HEL",   // todo
  "OTR1":"Diğer",
  "Loading":"Yükleniyor",

  "home":"Ana Sayfa",
  "pID":"Hasta Kimliği",
  "fullName":"Tam Adı ve soyadı",
  "gender":"Cinsiyeti",
  "height":"Yükseklik",
  "weight":"Kilosu",
  "cm":"cm",
  "kg":"kg",
  "birthday":"Doğum tarihi",
  "disType":"Tip 2 diyabet",
  "disDate":"Tanı tarihi",
  "Address":"Adres",
  "Postcode":"Posta kodu",
  "Inpatient":"Ayakta tedavi",
  "Yes":"Evet",
  "No":"Hayır",
  "Pno":"Hasta No",
  "Bno":"Yatak no.",
  "create":"Oluştur",
  "Telephone":"Telefon",

  "enterU":"Kullanıcı adını girin (e-posta)",
  "search":"Arama",
  "noU":"Kullanıcı adı gerekli.",
  "searchR":"Arama sonuçları",
  "uername":"Kullanıcı adı",
  "alias":"Takma Ad",
  "remove":"Kaldır",
  "viewG":"Grafikleri görüntüle",
  "sendR":"İstek gönder",
  "rSent":"İsteğiniz gönderildi.",
  "cancelR":"Cancel request",   // todo

  "VcodeTip1":"Didn’t receive it? Please wait for a few minutes and",   // todo
  "VcodeTip2":"try again.",   // todo
  "VcodeTip3":"We just sent a code to ",   // todo
  "Entercode":"Enter code",   // todo
  "Getcode":"Get code",   // todo

  "messages":"Mesajlar",
  "profile":"Profil",
  "sign out":"Oturumu Kapat",
  "changeP":"Parolayı Değiştir",
  "connection":"Bağlantı",

  "myP":"Profilim",
  "Portrait":"Profil resmi",
  "Profession":"Meslek",
  "DPRONF":"Belirtilmemiş",
  "DPROENDOCRIN":"Endokrinolog",
  "DPRODIABTRA":"Diyabet Eğitimcisi",
  "DPRONURSE":"Hemşire",
  "DPRODIATIT":"Diyetisyen",
  "DPROOTR":"Diğer Sağlık Çalışanları",
  "Organization":"Organizasyon",
  "Bio":"Bio",
  "save":"Kaydet",
  "oldPa":"Eski Parola ",
  "newPa":"Yeni Parola",
  "RePa":"Parolayı tekrar Girin",
  "forgetY":"Parolanızı mı unuttunuz?",
  "applyM":"Uygula",
  "oldErr":"The old password is incorrect.",   // todo
  "EntTheSame":"Enter the new password again.",   // todo
  "EnterOld":"Enter the old Password!",   // todo

  "pList":"Hasta Listesi",
  "connections":"Bağlantı",
  "settings":"Ayarlar",
  "monitor":"İzle",
  "graphs":"Raporlar",
  "events":"Olaylar",
  "records":"Kayıtlar",
  "qPrint":"Hızlı Yazdır",

  "sensorIn":"Sensör Bilgisi",
  "timeOfLaRead":"Son sensör okuma zamanı",
  "tranSn":"Verici SN",
  "status":"Durum",
  "sensorLife":"Kalan sensör ömrü",
  "lastSenorRead":"Son sensör okuması",
  "TranBattery":"Verici pili",
  "sg":"SG",
  "alert":"Dikkat!",
  "target":"Hedef",
  "hypo":"Hipo",
  "sensorGlucose":"Sensör Glikozu",
  "calib":"Kalibrasyon",
  "newSen":"Yeni sensör",
  "warm":"Isınma",
  "InsulinPump":"İnsülin pompası",
  "timeOfLaPump":"Son pompa verisinin zamanı",
  "pumpSN":"Pompa tabanı SN",
  "ReserviorLife":"Kalan depo rezervuar ömrü",
  "InsulinLeft":"İnsülin kaldı",
  "basal":"Bazal",
  "bolus":"Bolus",
  "totalBasal":"Toplam günlük bazal",
  "lastBolus":"Son bolus",
  "activeInsulin":"Aktif insülin",
  "totalBolus":"Toplam günlük bolus",
  "tampBasal":"Sıcaklık Bazal",
  "normalBolus":"Normal Bolus",
  "extendBolus":"Genişletilmiş Bolus",
  "manualStop":"Manuel Askıya Alma",
  "autoStop":"Otomatik Askıya Alma",
  "auto suspend":"Otomatik Askıya Alma",
  "stop":"Teslimat Durdurma",
  "newPatch":"Yeni yama",
  "tempBasal":"Sıcaklık Bazal",
  "N":"N",
  "E":"E",
  "CN1":"CN",
  "CE":"CE",

  "staticSettings":"Raporlama Ayarları",
  "dataSource":"Görüntülenecek veriler",
  "unit":"Birim",
  "glucoseTarget":"Glikoz Hedef Aralığı",
  "overall":"Tam",
  "Hypoglycemia":"Hipoglisemi ",
  "timePeriod":"Zaman dilimi",
  "postMeal":"Yemek Sonrası Analiz",
  "Breakfast":"Kahvaltı",
  "Lunch":"Öğle yemeği",
  "Dinner":"Akşam yemeği",
  "night":"Gece-vakti",
  "Before":"Önce",
  "After":"Sonra",
  "Low":"Düşük",
  "High":"Yüksek",
  "From":"‘den",
  "To":"Kime",
  "Hours":"hours",   // todo
  "Reset":"Varsayılanları geri yükle",
  "RealTime":"Gerçek zamanlı",
  "uploaded":"Yüklenen",
  "sensor":"Sensör",
  "pdmSN":"PDM SN",
  "startTime":"Başlangıç Zamanı",
  "endTime":"Bitiş süresi",
  "uploadTime":"Time of upload",   // todo
  "pdm":"PDM",
  "Uploaded":"Yüklenen",
  "Patch Pump":"Patch Pompa",
  "overLapp":"Sessions overlapped",   // todo
  "showAlert":"Uyarıları göster",

  "dashboard":"Gösterge  tablosu",
  "dboard_glucose_statistics":"Glucose Statistics",   // todo
  "dboard_glucose":"BG",
  "dboard_cgm":"CGM",
  "dboard_insulin":"Insülin",
  "dboard_carbs":"Karbonhidrat",
  "dboard_exercise":"Egzersiz",
  "dboard_glucose_avg":"Ortalama",
  "dboard_cgm_avg":"Ortalama",
  "dboard_insulin_avg":"Ortalama Günlük Doz",
  "dboard_carbs_avg":"Ortalama Karbonhidrat / Gün",
  "dboard_exercise_avg":"Ortalama Zaman / Gün",
  "dboard_sd":"SD",
  "dboard_num":"#",
  "dboard_num_days":"# days",   // todo
  "dboard_statistics":"İstatistik",
  "dboard_BG":"BG",
  "dboard_BG_calibration":"BG / calibration (per day)",   // todo
  "dboard_SG":"SG",
  "dboard_AUC_high":"AUC high >",   // todo
  "dboard_AUC_low":"AUC low <",   // todo
  "dboard_highest_value":"En yüksek değer",
  "dboard_lowest_value":"En düşük değer",

  "dboard_pump":"Pompa",
  "dboard_avg_daily_dose":"Ortalama Günlük Doz",
  "dboard_SD":"SD",
  "dboard_daily_basal":"Günlük Bazal",
  "dboard_daily_bolus":"Günlük Bolus",
  "dboard_avg_bolus_num":"Ortalama bolus no. günlük",
  "dboard_avg_suspend_time":"Ortalama Askıya alma süresi",
  "dboard_avg_reservoir_usage":"Ortalama Rezervuar kullanımı",
  "dboard_days":"days",   // todo

  "dboard_manual_bolus":"Manuel bolus (Gün başına hacim / sayı)",
  "dboard_normal":"-Normal",
  "dboard_extend":"-Genişletilmiş",
  "dboard_combo":"-Combo",

  "dboard_bolus_calculator":"Bolus (Gün başına hacim / sayı)",
  "dboard_food_bolus":"-Yiyecek bolus hesaplama",
  "dboard_corr_bolus":"-Corr bolus hesaplama",
  "dboard_override_add":"-Geçersiz kıl (+)",
  "dboard_override_sub":"-Geçersiz kıl (-)",

  "dboard_report":"Kontrol Paneli Raporu",

  "daily":"Günlük özet",
  "date":"Tarih      ",
  "print":"Baskı",
  "carbs":"Karbonhidrat",
  "exercise":"Egzersiz",
  "heavy":"Ağır",
  "Medium":"Orta",
  "Light":"Hafif",
  "dailyReport":"Günlük Özel Rapor",
  "devices":"Cihazlar",
  "tran":"Verici ",
  "pumpBase":"Pompa tabanı ",
  "HbA1c":"HbA1c",
  "statics":"İstatistik",
  "glucose":"Glikoz",
  "item":"Madde",
  "BG1":"BG",
  "SG1":"SG",
  "avgSD":"Ortalama (mmol/L)±SD",
  "avgSD1":"Ort ± SD",
  "min":"Minimum",
  "max":"Maksimum",
  "ofRead":"Okuma sayısı",
  "ofHypo":"# of hypo/duration(min)",   // todo
  "ofAlert":"Uyarı sayısı",
  "insulin":"Insülin",
  "insulin2":"Insülin",
  "totalDose":"Total daily dose",   // todo
  "foodBolus":"Food Bolus",   // todo
  "Food+coor":"Food+corr",   // todo
  "calibBolus":"Correction Bolus",   // todo
  "durationStop":"Duration of suspension(min)",   // todo
  "ofPumpAlert":"pompa uyarı sayısı",
  "ofMeal":"Öğün sayısı",
  "totalExerTime":"Toplam Egzersiz Zamanı",
  "exerNum":"Egzersiz sayısı",
  "avgInten":"Ort. Yoğunluk",
  "target1":"Hedef",
  "high1":"Yüksek",
  "low1":"Düşük",
  "BG Reading":"BG Reading",   // todo

  "dayByday":"Günden Güne Genel Bakış",
  "dayBydayRe":"Day by Day Overview Report",   // todo
  "period":"Dönem",

  "sensorOverlay":"Sensör Yerleşimi",
  "set":"Ayar",
  "setPeriod":"Süreyi ayarla",
  "Weekdays":"Hafta içi",
  "Weekends":"Hafta sonu",
  "Mon":"Pazartesi",
  "Tue":"Salı",
  "Wed":"Çarşamba",
  "Thur":"Perşembe ",
  "Thu":"Perşembe",
  "Fri":"Cuma",
  "Sat":"Cumartesi",
  "Sun":"Pazar",
  "Average":"Ortalama",
  "sensorOlRe":"Sensör Yerleşimi Raporu",
  "Avg":"Ortalama",
  "±SD":"±SD",   // todo
  "ofhypo":"Hipo sayısı",
  "Everyday":"Her gün",

  "TrendAna":"Trend Analizi",
  "TrendRe":"Trend Analizi Raporu",
  "sensorGlu":"Sensör Glikozu",
  "ofBGtest":"BG test sayısı",
  "Basics":"Temel",
  "static":"İstatistik",
  "Med":"Orta",
  "med":"median",   // todo
  "Q1":"Q1",   // todo
  "Q3":"Q3",   // todo
  "Q11":"Q1",   // todo
  "Q31":"Q3",   // todo
  "IQR":"IQR",
  "SD":"SD",
  "CV":"CV",
  "SE1":"SE  ortalama",
  "distri":"Distribution",   // todo
  "stab":"Stabilite",
  "#high":"# yüksek",
  "#low":"# Düşük",
  "aucBelow":"AUC Below limit",   // todo
  "aucAbove":"AUC Above limit",   // todo
  "bgRead":"BG okumaları",
  "total":"Avg Daily Total",   // todo
  "avg_daily_basal":"Avg Daily Basal",   // todo
  "avg_daily_bolus":"Avg Daily Bolus",   // todo
  "ofBolus":"Avg # of bolus/Day",   // todo
  "avgBolus":"Avg bolus(U)/Each",   // todo
  "Dura1":"Süre (dakika)",
  "Avg/Total":"Ortalama/Toplam",
  "high":"Yüksek",
  "low":"Düşük",
  "#hypo":"Hipo sayısı",
  "ofExer":"Egzersizlerin sayısı",

  "logbook":"Log book",
  "dailyTotal":"Günlük Toplam",
  "High Glucose":"Yüksek Glikoz",
  "Low Glucose":"Düşük Glikoz",
  "No Active Patch":"Aktif  Yama Yok",
  "Missed Meal":"Kaçırılan Yemek",
  "Multiple BG Readings":"Çoklu BG Okumaları",
  "Stop Patch":"Yamayı Durdur",
  "Others":"Diğerleri",
  "Other Events":"Diğer olaylar",
  "logRe":"Günlük Kayıt Defteri Raporu",

  "DeviceSetting":"Cihaz Ayarları İncelemesi",
  "Insulin Pump":"İnsülin pompası",
  "MaxBasalRate":"Azami Bazal oranı",
  "BasalPatterns":"Bazal Örüntüleri",
  "Selected Basal Pattern":"Seçilmiş Bazal Örüntüi",
  "Maximum Bolus":"Maksimum Bolus",
  "Combo/Extended Bolus":"Birleşik / Genişletilmiş Bolus",
  "BG Reminder":"BG Hatırlatma",
  "Bolus Increment":"Bolus Artışı",
  "Bolus Calculator":"Bolus Hesaplama",
  "Active Insulin Time":"Aktif İnsülin Süresi",
  "IC Ratios":"IC Ratios",   // todo
  "Insulin Sensitivity":"İnsülin Hassasiyeti",
  "BG Target":"BG Hedef",
  "Bolus Reminder":"Bolus Hatırlatıcı",
  "CGM":"CGM",
  "CGM System":"CGM sistemi",
  "Glucose Unit":"Glikoz Ünitesi",
  "Glucose Limits":"Glikoz Sınırları",
  "Predicitive Alerts":"Tahmini Uyarılar",
  "Rate Alerts":"Oran Uyarıları",
  "type":"Türü",
  "time":"Zaman",
  "data":"Veri",
  "Rate":"Rate",   // todo
  "Calibration Reminder":"Kalibrasyon Hatırlatıcı",
  "Calibration Repeat":"Kalibrasyon Tekrarı",
  "Snooze":"Erteleme",
  "Audio Options":"Ses Seçenekleri",
  "Confidence Reminder":"Güven Hatırlatıcı",
  "Backlight":"Arka Işık",
  "Sec":"saniye",
  "Alarm Clock":"Alarm saati",
  "Patch Expiration":"Patch/Reservuar Bitişi",
  "Sensor Expiration":"Sensör Son Kullanma Tarihi",
  "Hourly Max":"Saatlik Maksimum",
  "Daily Max":"Günlük Maksimum",
  "Low Reservoir":"Düşük Rezervuar",
  "Low Suspend":"Düşük Askıya Alma",
  "Predictive Low Suspend":"Tahmini Düşük Askıya Alma",
  "Rise":"Yüksellme",
  "Fall":"Düşme",
  "Auto Off":"Otomatik Kapatma",
  "Standard":"Standart",
  "Exercise":"Egzersiz",
  "Holiday":"Tatil",
  "ProgramA":"Örüntü A",
  "ProgramB":"Örüntü",
  "--":"--",   // todo
  "Insulin":"Insülin",

  "SUSA":"Otomatik Kapatma",
  "SUSHM":"Maksimum 1 Saatlik Teslimatı aşıyor",
  "SUSDM":"Maksimum TDD'yi aşıyor",
  "SUSLSG":"Düşük Askıya Alma",
  "SUSPLSG":"Tahmini Düşük Askıya Alma",
  "Pump Restarted":"Pompa Yeniden Başlatıldı",
  "Meter BG Now":"Metre BG Şimdi",
  "Sensor Exp in 2 Hours":"Sensör 2 Saat İçinde Sona Erecek",
  "Sensor Exp in 6 Hours":"Sensör 6 Saat İçinde Sona Erecek",
  "Sensor Exp in 30 Min":"Sensör 30 Dakika İçinde Sona Erecek",
  "Sensor Calibration Error":"Sensor Calibration Error",   // todo
  "Sensor Error":"Okuma Yok",

  "Device Settings Report":"Cihaz Ayarları Raporu",
  "24h Total":"24saat=Toplam",
  "Device Settings at":"Device Settings at",   // todo
  "Start":"Başlat",
  "Combo/Ext Bolus":"Birleşik / Genişletilmiş Bolus",
  "Time Format":"Zaman formatı",
  "Device Options（CGM System)":"Device Options (CGM System)",   // todo
  "Device Options（Insulin Pump)":"Device Options (Insulin Pump)",   // todo
  "Dispay Settings (Screen)":"Ekran Ayarları (Ekran)",
  "Dispay Settings (Backlight)":"Ekran Ayarları (Arka Işık)",
  "Graph Range":"Grafik Aralığı",
  "Range":"Range",   // todo
  "Repeat":"Tekrar",
  "Glucose Alerts":"Glikoz Uyarısı",
  "Alert Silence":"Uyarı Sessizliği",

  "Create":"Oluştur",
  "Event Filter":"Olay Filtresi",
  "HbA1c1":"HbA1c",
  "Urine Ketone":"Ketone",   // todo
  "Injection":"Enjeksiyon",
  "Other":"Diğer",
  "Event Type":"Etkinlik Türü",
  "Details":"Detaylar",
  "Notes":"Notlar",
  "Source":"Kaynak",
  "edit":"Düzenle",
  "Action":"Aksiyon",
  "EventReport":"Etkinlik Özeti Raporu",
  "By Date":"Tarihe göre",
  "By Category":"Kategoriye göre",
  "Event Summary":"Etkinlik Özeti ",
  "No data":"Veri yok",
  "No1":"Hayır",
  "data1":"data",   // todo
  "#":"#",
  "BG Summary":"BG Özeti",
  "Carbs Summary":"Karbonhidrat Özeti",
  "Injection Summary":"Enjeksiyon özeti",
  "Exercise Summary":"Egzersiz Özeti",
  "Input Notes":"Not gir",

  "Profile":"Profil",
  "Complications":"Komplikasyonlar",
  "Concomitant diseases":"Eşlik eden hastalıklar",
  "Suggestion":"Suggestions",   // todo
  "Coronary heart disease":"Koroner Kalp hastalıklarında",
  "High blood lipids":"Yüksek kan lipitleri",
  "High blood pressure":"Yüksek tansiyon",
  "Kidney disease":"Böbrek hastalığı",
  "Neuropathy":"Nöropati ",
  "Obesity":"Obezite",
  "Peripheral arterial disease":"Koroner arter hastalıklarında",
  "Retinopathy":"Retinopati",
  "Smoking addiction":"Sigara bağımlılığı",
  "Enter date":"Tarih girin",
  "Enter suggestion":"Öneri girin",
  "Enter Notes":"Enter Notes",   // todo
  "Select":"Seçim",
  "Prescription":"Reçete",
  "Medicine":"ilaç",
  "Dose":"Doz",
  "Enter medicine":"İlaç girin",
  "Enter dose":"Dozu girin",
  "Enterdis":"Enter concomitant diseases",   // todo
  "Add note":"Yeni Not",
  "Add Content":"Maximum length is 1000 characters.",   // todo
  "Other suggestions":"Diğer öneriler",
  "OK":"TAMAM",
  "HCP":"HCP",
  "Content":"İçerik",
  "Records Report":"Kayıt Raporu",

  "Quick Print":"Hızlı Yazdır",
  "Quick Print Settings":"Hızlı Yazdırma Seçenekleri",
  "Select duration":"Süre seç:  ",
  "One Week":"Bir hafta",
  "One Month":"Bir ay",
  "One Quarter":"Bir çeyrek",
  "End date":"Bitiş tarihi",
  "Yesterday":"Dün",
  "Last Sunday":"Geçen pazar",
  "Last Saturday":"Geçen cumartesi",
  "Last Day of Last Month":"Last Day of Last Month",   // todo
  "Last Day of Last Quarter":"Last Day of Last Quarter",   // todo
  "Customized":"Özelleştirme",
  "Week Filter":"Hafta Filtresi",
  "Select reports to print":"Yazdırılacak raporları seçin",
  "Daily Summary":"Günlük özet",
  "Day By Day Overview":"Günden Güne Genel Bakış",
  "Sensor Overlay":"Sensör Yerleşimi",
  "Trend Analysis":"Trend Analizi",
  "Logbook":"Log book",
  "Device Settings Review":"Cihaz Ayarları İncelemesi",
  "createReport":"Rapor Oluştur",

  "Segment Analysis":"Segment Analizi",
  "Sensor Glucose Profile":"Sensör Glikoz Profili",
  "# of Boluses":"Bolus Sayısı",
  "Bolus Insulin":"Bolus Insulin",   // todo
  "Basal Pattern":"Basal Pattern",   // todo
  "Segment Analysis Report":"Segment Analiz Raporu",
  "Avg Glucose":"Avg Glucose",   // todo
  "Below":"Below",   // todo
  "In Target Range":"Hedef Alanında",
  "Coefficient of variation":"Varyasyon katsayısı",
  "% Time CGM Active":"% Zaman CGM Aktif",
  "est_a1c_t1":"Estimated A1C:",   // todo
  "est_a1c_t2":"calculated from SG values",   // todo
  "est_a1c_t3":"Not: Tahmini A1C laboratuar ölçümünün yerini almaz",

  "acceptTip":" has permitted you to remotely view his/her health information.",   // todo
  "cancelTip":" has stopped permitting you to remotely view his/her health information. You can apply again if necessary.",   // todo
  "rejectTip":" has rejected your remote view application.",   // todo
  "Read":"Oku",

  "Connection":"Bağlantı",
  "connections1":"Bağlantı",
  "Add Connection":"Bağlantı ekleyin",
  "SG":"SG",
  "Active Insulin":"Aktif insülin",
  "Stop following":"Takip etmeyi bırak",
  "Enter username (email)":"Kullanıcı adını girin (e-posta)",
  "Search results":"Arama sonuçları",
  "Send request":"İstek gönder",
  "View graphs":"Grafikleri görüntüle",
  "Agree":"Katılıyorum",
  "Deny":"Reddedildi",
  "Remove":"Kaldır",
  "Cancel Requset":"İsteği iptal et",
  "Remark":"Açıklama",

  "Warm up":"Isınma",
  "Monitoring":"Görüntüleme",
  "Transmitter Error":"Verici Hatası",
  "Sensor Failure":"Sensör Arızası",
  "Sensor Expired":"Sensör Süresi Doldu",
  "Lost Sensor":"Kayıp sensör",
  "Not Calibrated":"Kalibre Edilmedi",
  "Calibrating":"Kalibrasyon",
  "Calibration Needed":"Kalibrasyon Gerekli",
  "Calibration Error":"Kalibrasyon Hatası",
  "Charging Battery":"Batarya Şarj oluyor",
  "Battery Charged":"Batarya Şarj Edildi",

  "To be filled":"Doldurulacak",
  "Filled with insulin":"İnsülinle dolu",
  "Priming":"Hazırlanıyor",
  "Priming completed":"Kullanıma hazırlama tamamlandı",
  "Inserting needle":"İğne ekleniyor",
  "Patch activated":"Yama aktif",
  "Delivering Basal":"Bazal Teslimi",
  "Exceeds Max 1 Hour Delivery":"Maksimum 1 Saatlik Teslimatı aşıyor",
  "Exceeds Max TDD":"Maksimum TDD'yi aşıyor",
  "Suspend":"Askıya Alınmış",
  "Occlusion Detected":"Tıkanma Algılandı",
  "Patch Expired":"Yama Süresi Doldu",
  "Empty Reservoir":"Boş Rezervuar",
  "Patch Error":"Yama Hatası",
  "Pump Base Error":"Pompa tabanı Hatası",
  "Patch Battery Depleted":"Yama Pili Tükenmiş",
  "Magnetic sensor not calibrated":"Manyetik sensör kalibre edilmemiş",

  "Patient Profile":"Patient Profile",   // todo

  "On":"Açık",
  "on":"Açık",
  "Off":"Kapalı",
  "off":"Kapalı",

  "CORONARY_HEART_DISEASE":"Koroner Kalp hastalıklarında",
  "HIGH_BLOOD_LIPIDS":"Yüksek kan lipitleri",
  "HIGH_BLOOD_PRESSURE":"Yüksek tansiyon",
  "KIDNEY_DISEASE":"Böbrek hastalığı",
  "NEUROPATHY":"Nöropati ",
  "OBESITY":"Obezite",
  "PERIPHERAL_ARTERIAL_DISEASE":"Koroner arter hastalıklarında",
  "RETINOPATHY":"Retinopati",
  "SMOKING_ADDICTION":"Sigara bağımlılığı",

  "saveTip":"Başarılı şekilde kaydedildi.",
  "changePaTip":"Parolanız başarılı bir şekilde değiştirildi.",
  "enterEmTip":"E-mail adresini girin.",
  "verErrTip":"Doğrulama kodu yanlış.",
  "chooseEventTip":"Yazdırılacak olayları seçin",
  "chooseDataTip":"Select data to print",   // todo
  "dateWrongTip":"Bitiş tarihi, başlangıç tarihinden önce olmamalıdır.",
  "infoWrongTip":"Lütfen gerekli tüm alanları doldurunuz.",
  "createdSuccssTip":"Başarıyla düzenlendi",
  "selectData":"Select data to save",   // todo

  "acceSu":"Accepted connection request",   // todo
  "acceEr":"Failed to add new connection",   // todo
  "rejeSu":"Rejected connection request",   // todo
  "rejeEr":"Failed to reject request",   // todo

  "userNotExist":"Kullanıcı adı mevcut değil.",
  "Password incorrect":"Parola yanlış.",
  "UserType incorrect":"Incorrect user type",   // todo

  "registSuccess":"Your account has been successfully created.",   // todo
  "registFailed":"Failed to register a new account.",   // todo
  "sentSuccess":"Message sent successfully",   // todo
  "sentFailed":"Failed to send message",   // todo
  "Input error":"Giriş hatası",

  "deletePtip":"Bu hastaları silmek istediğinden emin misiniz?",
  "deleteEvents":"Bu etkinlikleri silmek istediğinize emin misiniz?",
  "deleteData":"Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",   // todo
  "deleteThis":"Silmek istediğinizden emin misiniz?",
  "confirm":"Onayla",
  "deleteSuccess":"Başarıyla silindi",
  "deleteFailed":"Failed to delete item",   // todo
  "modifySuccess":"Changed successfully",   // todo
  "modifyFailed":"Failed to change",   // todo
  "createSuccess":"Başarıyla düzenlendi",
  "createFailed":"Oluşturma başarısız oldu",
  "editSuccess":"Düzenleme başarılı",
  "editFailed":"Düzenleme başarısız oldu",
  "Time overlapped":"The sessions you selected overlapped each other.",   // todo

  "stopFollow":"Bu hastayı takip etmeyi bırakmak istediğinize emin misiniz?",
  "CancelTip1":"Are you sure to you want to delete this connection?",   // todo

  "Warning":"Uyarı",
  "agreeConnect":"If you click “Agree”to accept the connection request, your health data will become available to the new connection.",   // todo
  "denyConnect":"Are you sure you want to reject the connection request?",   // todo
  "deleteConnect":"Are you sure you want to delete this connection? If you delete him/her, the connection will not be able to view your health data any more.",   // todo

  "Choose the events to print":"Choose the events to print",   // todo
  "tryAgain":"Tekrar deneyin",
  "username and password is required":"username and password is required",   // todo
  "A name is required":"A name is required",   // todo
  "username is required":"Username is required",   // todo
  "The date choose wrong":"Tarih yanlış seçildi",
  "Date no more than 14 days":"You cannot select more than 14 days.",   // todo

  "CancelTip":"Are you sure you want to delete the connection?",   // todo
  "removeConnect":"Başarıyla silindi",

  "dateErr1":"You cannot select more than 90 days.",   // todo
  "dateErr2":"Bitiş tarihi, başlangıç tarihinden önce olmamalıdır.",

  "Not Filled":"Belirtilmemiş",
  "Today":"Bugün",
  "duration":"Süre",
  "interval":"Interval",   // todo
  "7 days":"7 gün",
  "14 days":"14 gün",
  "30 days":"30 days",   // todo
  "90 days":"90 days",   // todo
  "g":"g",   // todo

  "Sound+Vibrate":"Ses + Titreşim",
  "Sound":"Ses",
  "Vibrate":"Titreşim",
  "Silent":"Rahatsız etmeyin",
  "1":"Bir kez",
  "2":"Günlük",
  "noMes":"There is no message.",   // todo
  "noConnect":"There is no connection.",   // todo
  "Customize":"Özelleştirme",
  "GB":"United Kingdom",   // todo
  "CN":"China",   // todo
  "FR":"France",   // todo
  "DD":"Germany",   // todo
  "DE":"Germany",   // todo
  "SE":"Sweden",   // todo
  "AU":"Australia",   // todo
  "HKF":"Hongkong",   // todo
  "HU":"Hungary",   // todo
  "IT":"Italy",   // todo
  "NL":"Netherlands",   // todo
  "Nor":"Norway",   // todo
  "PT":"Portugal",   // todo
  "ES":"Spain",   // todo
  "TR":"Turkey",   // todo

  "Jan":"Jan",   // todo
  "Feb":"Feb",   // todo
  "Mar":"Mar",   // todo
  "Apr":"Apr",   // todo
  "May":"May",   // todo
  "Jun":"Jun",   // todo
  "Jul":"Jul",   // todo
  "Aug":"Aug",   // todo
  "Sep":"Sep",   // todo
  "Oct":"Oct",   // todo
  "Nov":"Nov",   // todo
  "Dec":"Dec",   // todo
  "ApplyTip":" request to view your data.",   // todo
  "noReadings":"Okuma Yok",

  "daop_A6_system":"A6 Touchcare System",   // todo
  "daop_easytouch_easyview":"EasyTouch / EasyView iPad",   // todo
  "daop_TY012_TY015":"TY012/TY015",   // todo
  "daop_easysense":"EasySense",   // todo
  "daop_delete_data":"Delete Data",   // todo
  "daop_uploaded_data":"Yüklenen Veri",
  "daop_uploaded_data_text":"Veriler EasyTouch Uygulamasından veya EasyView iPad Uygulamasından alınmıştır.",
  "daop_realtime_data":"Gerçek zamanlı veri",
  "daop_realtime_data_text":"The data is from EasySense App or EasyPatch App.",   // todo

  "ins_unit":"(U)",
  "ins_unit2":"U",
  "basal_unit":"(U/H)",
  "basal_unit2":"U/H",
  "dump_last":"Dump End",   // todo

  // 告警
  "Alerts_Patch_Battery_Low":"Yama Pili Düşük",
  "Alerts_Patch_Battery_Depleted":"Yama Pili Tükenmiş", // update
  "Alerts_Lost_Pump":"Lost Pump",
  "Alerts_Low_Reservoir":"Düşük Rezervuar", // update
  "Alerts_Empty_Reservoir":"Boş Rezervuar",
  "Alerts_Patch_Expiration_Advisory":"Yama Bitişi Danışmanlığı",
  "Alerts_Patch_Exp_In_1_Hour":"Patch Exp In 1 Hour",
  "Alerts_Patch_Expired":"Yama Süresi Doldu", // update
  "Alerts_Patch_Error":"Yama Hatası",
  "Alerts_Pump_Base_Error":"Pompa tabanı Hatası",
  "Alerts_Basal_Rate_Key_Error":"Basal Rate Key Error",
  "Alerts_Occlusion_Detected":"Tıkanma Algılandı", // update
  "Alerts_End_Of_Suspend":"End Of Suspend",
  "Alerts_Exceeds_Max_TDD":"Maksimum TDD'yi aşıyor", // update
  //"Alerts_Exceeds_Max_TDD":"Exceeds Max TDD",
  "Alerts_Exceeds_Max_1Hr_Delivery":"Maksimum 1saat Teslimatı aşıyor",
  //"Alerts_Exceeds_Max_1Hr_Delivery":"Exceeds Max 1Hr Delivery",
  "Alerts_Predictive_Low_Suspend":"Tahmini Düşük Askıya Alma", // update
  "Alerts_Low_Suspend":"Düşük Askıya Alma",
  "Alerts_Auto_Off":"Otomatik Kapatma", // update

  "Alerts_Pump_Restart":"Pump Restart",  // 22
  "Alerts_Auto_Off_Warning":"Auto Off Warning",  // 23
  "Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //24
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  // 25
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //33

  "Alerts_Lost_Sensor":"Kayıp sensör", // update
  "Alerts_Transmitter_Battery_Low":"Verici Pili Düşük",
  "Alerts_Charge_Transmitter":"Şarj vericisi",
  "Alerts_Sensor_Error":"Okuma Yok",
  "Alerts_Transmitter_Error":"Verici Hatası",
  "Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  //"Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  "Alerts_Sensor_Failure":"Sensör Arızası",
  "Alerts_Sensor_Calibration_Reminder":"Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now":"Metre BG Şimdi",
  "Alerts_Sensor_Exp_in_6_Hours":"Sensör 6 Saat İçinde Sona Erecek",
  "Alerts_Sensor_Exp_in_2_Hours":"Sensör 2 Saat İçinde Sona Erecek", // update
  "Alerts_Sensor_Exp_in_30_Min":"Sensör 30 Dakika İçinde Sona Erecek",
  "Alerts_Sensor_Expired":"Sensör Süresi Doldu", // update
  "Alerts_Rapid_Rise":"Hızlı yükseliş",
  "Alerts_Rapid_Fall":"Hızlı Düşüş",
  "Alerts_High_Predicted":"Yüksek Tahmin",
  "Alerts_Low_Predicted":"Düşük Tahmin",
  "Alerts_High_Glucose":"Yüksek Glikoz", // update
  "Alerts_Low_Glucose":"Düşük Glikoz", // update
  "Alerts_Below_3.1_mmol/L":"3.1 mmol / L'nin altında",
  "Alerts_Transmitter_Battery_Low_2":"Verici Pili Düşük",

  "Alerts_PDM_Battery_Low":"PDM Batarya Düşük",
  "Alerts_Replace_Battery":"KUM şimdi şarj et",

  // Alert页面
  "Alert":"Alert",
  "Alerts":"Uyarılar",
  "Alert Filter":"Alert Filter",
  "PDM":"PDM",
  "Pump":"Pompa",
  //"CGM":"CGM",

  "Out Of Range": "Out Of Range",
  "t1221_Time_in_Auto_Mode":"Auto Modundaki zaman",
  "t1221_Average_SG_SD":"Averaj SG ± SD",
  "t1221_Time_in_Target_Range":"Hedef araliktaki zaman",
  "t1221_Time_above_Range":"hedef aralik uzerindeki zaman",
  "t1221_Time_below_Range":"hedef aralik altindaki zaman",
  "t1221_Auto_Basal_per_day":"Auto Basal (gün)",
  "t1221_Auto_Bolus_per_day":"Auto Bolus (gün)",
  "t1221_Auto_Mode_Exits":"Auto Modu cikis",
  "t1221_No_Sensor_readings":"sensor okumasi yok",
  "t1221_Max_Delivery":"max iletim",
  "t1221_Min_Delivery":"min iletim",
  "t1222_autoModeBasal":"basal Auto modu",
  "t1222_autoModeCorrBolus":"auto modu bolus duzelt",
  "t1222_autoSnack":"auto atıştırma",
  "t1222_autoBreakfast":"auto kahvalti",
  "t1222_autoLunch":"auto oglen yemek",
  "t1222_autoDinner":"auto aksam yemek",
  "t1222_autoExercise":"auto egzersiz",
  "t1222_Snack":"Atıştırma",
  "t1222_Auto_Mode":"Auto Modu",
  "t1222_Time_in_Auto_Mode":"auto modundaki zaman(%)",
  "t1222_Avg_SD":"Avg.(mmol/L)±SD",
  "t1222_Target_Range":"hedef aralik(%)",
  "t1222_Above_Range":"hedef aralik uzeri(%)",
  "t1222_Below_Range":"Hedef aralik alti(%)",
  "t1222_Auto_Mode_Exits":"# auto modundan cikisi sayisi",
  "t1221_Auto_Mode":"Auto Modu",
  "t1222_auto_basal":"Oto Bazal",
  "t1222_auto_bolus":"Oto Bolus",
  "t0805_User_Management":"Kullanıcı yönetimi",
  "t0805_Patient_Management":"Hasta yönetimi",
  "t0805_Operation_History":"Operasyon Geçmişi",
  "t0805_User_List":"Kullanıcı listesi",
  "t0805_User":"kullanıcı",
  "t0805_Time":"Zaman",
  "t0805_Operation_Type":"Operasyon türü",
  "t0805_Back":"Geri",
  "t0805_Add":"Ekle",
  "t0805_Delete":"Sil",
  "t0809_Add_User":"Kullanıcı Ekle",
  "t1028_Pattern_C":"Örüntü C",
  "t1028_Pattern_D":"Örüntü D",
  "t1029_Auto_meal_bolus":"Auto meal bolus",
  "t1029_Auto_mode_correction_bolus":"Auto mode correction bolus",
  "t1029_Sick":"Hasta",
  "t1029_Auto_Mode_Feature":"Oto Mod özelliği",
  "t1029_Target_SG":"Hedef SG",
  "t1029_Auto_Meal_Handling":"Oto Öğün İdaresi",
  "t1029_Total_Daily_Dose":"Günlük Toplam Dozu",
  "t1029_Pump_Light":"Pompa Işığı",
  "t1029_Alerts_for_Hypo":"Hİpo İçİn İkaz",
  "t1102_Out_of_Range":"Menzil disinda",
  "t1102_Command_Reminder":"Emir hatırlatması",
  "t1102_Alarms_Alerts_on_APP":"Pompa alarm ve ikazları",
  "t1102_Alarms_on_App":"App alarmları",
  "t1102_Alerts_on_App":"Düşük KŞ ikazlar",
  "t1102_Factory_Calibration":"Fabrika kalibrasyonu",
  "t1102_Alerts_for_Low":"Düşük KŞ ikazlar",
  "t1102_Alerts_for_High":"Yüksek KŞ ikazlar",
  "t1102_Alerts_for_Others":"Diğer ikazlar",
  "t1102_Adjustment":"Ayarlama",
  "t1102_Suggested":"Önerilen",
  "t1103_Glucose":"Glikoz",
  "t1103_CGM":"CGM",
  "t1103_Insulin":"Insülin",
  "t1103_Carbs":"Karbonhidrat",
  "t1103_Exercise":"Egzersiz",
  "t1103_Min_Max":"Min/Max",
  "t1103_Target_Range":"Target Range",
  "t1103_Overall_Tine_In_Range":"Overall: Time In Range",
  "t1103_Basal":"Basal",
  "t1103_Bolus":"Bolus",
  "t1103_Basal_Bolus":"Basal & Bolus",
  "t1103_Auto_Mode_Time_In_Range":"Auto Mode: Time In Range",
  "t1103_Time_below_range":"Time below range",
  "t1103_Time_above_range":"Time above range",
  "t1103_Time_in_target_range":"Time in target range",
  "t1103_Incorrect_Password":"Yanlış Şifre, $1 Deneme kaldı, lütfen doğru Şifreyi girin.",
  "t1103_Incorrect_locked":"Başarısız Denemeler sınırı aşıyor, hesap kilitlendi. Lütfen $1 dakika sonra tekrar deneyin.",
  "t1104_The_data_is_from":"Veriler EasySense Uygulamasından veya EasyPatch Uygulamasından alınmıştır.",
  "t1104_Privacy_Policy":"Kişisel Veri Gizliliği Politikasi ve Kullanim Kosullari",
  "t1104_updated_privacy_policy":"Kişisel Veri Gizliliği Politikasi ve Kullanim Kosullari güncelledik. Lutfen kullanmaya başlamadan once dikkatle okuyun.",
  "t1104_Disagree":"Kabul ediyorum",
  "t1104_Agree":"Katılıyorum",
  "t1105_Upload_History":"Yükleme Geçmişi",
  "t1105_Delete_Data":"Verileri sil",
  "t1105_Target_Range":"Target Range",
  "t1105_request_to_view_your_data":"Verilerinizi görüntülemek için $1 istek.",
  "t1105_Recent_Updates":"Son Güncellemeler",
  "t1108_No_data":"Veri yok",
  "t1108_Pump_Bash_SN":"Pompa tabanı SN",
  "t1108_Transmitter_SN":"Verici SN",
  "t1112_Normal_Glucose":"Normal Glikoz",
  "t1112_Manual_Bolus_or_Modified_Bolus":"Manuel Bolus veya Değiştirilmiş Bolus",
  "t1112_Auto_Mode_Started":"Oto Mod Başladı",
  "t1112_Auto_Mode_Exit":"Oto Mod Çıkış",
  "t1112_Normal_Bolus":"Normal Bolus",
  "t1112_Extended_Bolus":"Uzatılmış Bolus",
  "t1112_Combo_Bolus":"Combo bolus",
  "t1112_Carbs":"Karbonhidrat",
  "t1112_Glucose":"Glikoz",
  "t1112_BG":"Kan şekeri ",
  "t1112_Audio":"Ses",
  "t1112_Tone":"Ton",
  "t1112_Audio_Options":"Ses Seçenekleri",
  "t1112_Weight_Unit":"Ağırlık Birimi",
  "t1112_Height_Unit":"Yükseklik Birimi",
  "t1112_Not_available":"Müsait Değil",
  "t1112_Number":"Sayı",
  "t1112_days":"# günlr",
  "t1112_min":"dk",
  "t1113_days":"günlr",
  "t1215_Security":"Güvenlik",
  "t1215_MFA":"Çok faktörlü kimlik doğrulama (MFA)",
  "t1215_Enter_verification_code":"Dogrulama kodunu giriniz",
  "t1215_Multi_factor_ON":"Çok faktörlü kimlik doğrulama AÇIK. Doğrulama kodu $1 adresine gönderildi Lütfen doğrulama kodunu gönderin.",
  "t1215_Verification_code_incorrect":"Doğrulama kodu yanlış",
  "t1215_Show_Glucose_Value":"Glikoz değerini göster",
  "t1221_enter_verification_code":"Lütfen $1'e gönderilen 6 haneli doğrulama kodunu girin.",
  "t1221_Verification_Success":"Başarıyla doğrulandı",
  "t1222_We_will_only_process":"Sağlık hizmeti bilgilerinizi sizin rızanız halinde Medtrum APP/Web Sitesinde işleyeceğiz. ",
  "t1222_If_you_are_under_years":"Eğer 16 yaşından küçükseniz, bu uygulamaya kaydolmak için ebeveyn veya yasal velinizin rızası olmak zorundadır.",
  "t1221_register_cn":"APP'e hiç bir cihaz bilgisini yüklememe hakkına sahipsiniz, böylelikle bilgiler diğerleri tarafından ulaşılamaz olacaktır. Eğer Medtrum APP/Web Sitesine kaydolmayı seçmezseniz, tek sağlık bilginiz cihazdakiler olacaktır. ",
  "t1221_register_eu":"Eğer Medtrum hesabınızı kaydetmeyi ve hesabı kullanarak APP'e ulaşmayı seçerseniz, APP'te kaydedilen sağlık bilgileriniz Avrupa'daki serverlarımıza yüklenip 2 yıl süreyle saklanacaktır. APP'e hiç bir cihaz bilgisini yüklememe hakkına sahipsiniz, böylelikle bilgiler diğerleri tarafından ulaşılamaz olacaktır. Eğer Medtrum APP/Web Sitesine kaydolmayı seçmezseniz, tek sağlık bilginiz cihazdakiler olacaktır.",
  "t1221_register_follow":"Sağlık hizmeti bilgilerinizi sizin rızanız halinde Medtrum APP/Web Sitesinde işleyeceğiz.",
  "t1222_Terms_of_Use":"Medtrum Kullanım Koşullarına",
  "t1222_Privacy_Policy":"Medtrum'un Gizlilik Politikasına",
  "t1222_Create_Account":"Hesap aç",
  "t1222_Back":"Geri",
  "t1222_Verify_your_account":"Hesabınızı doğrulayın",
  "t1222_please_check_your_account":"$1'e bir Doğrulama Kodu göndereceğiz, lütfen hesabınızı kontrol edin.",
  "t1222_I_Agree_to":"$1 Katılıyorum",
  "t1223_Invalid_Verification_Code":"Geçersiz Doğrulama Kodu. Lütfen tekrar deneyin.",
}

//export  default {trMessages}



// WEBPACK FOOTER //
// ./src/lang/tr.js